import {
    ActionButton,
    isButtonType,
    OpenShopAction,
} from '../../model/components/ActionButton';
import { Media } from '../../model/components/Media';
import { PostData } from '../../model/PostTypes';
import { PathContextProvider } from '../../PathContext';
import { ActionButtonInput } from './ActionButtonInput';
import { MediaInput } from './MediaInput';
import { TranslationTableInput } from './TranslationTableInput';
import { TranslationTable } from '@lifeserver/shared';

import { assert } from '../../../utils/assert';

const SUPPORTED_SIZES = ['Large', 'Medium'] as const;
type ShopLinkPostSize = (typeof SUPPORTED_SIZES)[number];

export interface ShopLinkPostData {
    $type: 'ShopLink';
    size: ShopLinkPostSize;
    coverMedia?: Media;
    header: TranslationTable;
    button: ActionButton & { action: OpenShopAction };
}

export const isShopLinkPostData = (
    value: PostData,
): value is ShopLinkPostData => {
    return (
        value.$type === 'ShopLink' &&
        SUPPORTED_SIZES.some((size) => size === value.size) &&
        value.header.$type === 'TranslationTable' &&
        isButtonType(value.button, 'OpenShop')
    );
};

export interface VideoInputProps {
    value: ShopLinkPostData;
    onChange?: (value: ShopLinkPostData) => void;
}

export const ShopLinkPostInput = ({ value, onChange }: VideoInputProps) => {
    const onFieldChange = <Field extends keyof ShopLinkPostData>(
        field: Field,
        fieldValue: ShopLinkPostData[Field],
    ) => {
        onChange?.({
            ...value,
            [field]: fieldValue,
        });
    };
    return (
        <>
            <fieldset>
                <legend>Cover Media</legend>
                <MediaInput
                    value={value.coverMedia}
                    onChange={(media) => onFieldChange('coverMedia', media)}
                />
            </fieldset>
            <fieldset>
                <legend>Header</legend>

                <PathContextProvider segment="header">
                    <TranslationTableInput
                        value={value.header}
                        onChange={(header) => onFieldChange('header', header)}
                    />
                </PathContextProvider>
            </fieldset>
            <fieldset>
                <legend>Button</legend>
                <PathContextProvider segment="button">
                    <ActionButtonInput
                        value={value.button}
                        onChange={(button) => {
                            assert(
                                isButtonType(button, 'OpenShop'),
                                "Button doesn't have open shop action",
                            );
                            onFieldChange('button', button);
                        }}
                    />
                </PathContextProvider>
            </fieldset>
        </>
    );
};
